import { useRecoilState } from 'recoil';
import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { permissions as permissionsAtom } from '../../atoms/Users';
import { selectedPage as selectedPageAtom } from '../../atoms/PageState';
import { getUserPermissions } from '../../variables/Users';
import { getPagesListByPermission } from '../../variables/Pages';
import { PageType } from '../../interfaces/Page';
import PayHistory from './PayHistory';

const PayHistoryPageRoot = () => {
  const [permissions, setPermissions] = useRecoilState(permissionsAtom);
  const [selectedPage, setSelectedPage] = useRecoilState(selectedPageAtom);

  useEffect(() => {
    setPermissions(getUserPermissions());
  }, []);

  useEffect(() => {
    const pages = getPagesListByPermission(permissions);
    let index = -1;
    for (let i = 0; i < pages.length; i += 1) {
      if (pages[i].pageType === PageType.PAY_HISTORY) {
        index = i;
        break;
      }
    }

    if (selectedPage !== index) {
      setSelectedPage(index);
    }
  }, [permissions]);

  return (
    <Routes>
      <Route path={'/'} element={<PayHistory />}></Route>
      <Route path={'/:submittedValue'} element={<PayHistory />}></Route>
    </Routes>
  );
};

export default PayHistoryPageRoot;
